import { c as _c } from "react/compiler-runtime";
export const ChartLoading: React.FC<React.PropsWithChildren> = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute mx-auto top-1/2 left-0 right-0 text-center"><span className="text-lg text-opacity-80">Loading chart data...</span></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};